import { Button, Modal, message } from 'antd';
import Utils from '@utils/utils'
import { useEffect, useState } from 'react';
import styles from './mobileModal.module.scss'
import {useLocation} from 'react-router-dom'
import PSAIModal from '@PSAIComponents/PSAIModal';

const MobileModal = () => {
    // const [isMobile] = useState(Utils.isMobileDevice())
    // const [modalOpen, setModalOpen] = useState(Utils.isMobileDevice())
    const location = useLocation()
    const [modalOpen, setModalOpen] = useState()

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const showNotice = searchParams.get('show_notice')
        if (showNotice) {
            if (showNotice != '0') setModalOpen(Utils.isMobileDevice())
        } else {
            setModalOpen(Utils.isMobileDevice())
        }
    }, [])

    const copy = () => {
        const text = 'https://www.psai.cn/';
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(text)
            .then(() => {
                console.log('内容已成功复制到剪贴板');
                message.success('已复制链接')
                setModalOpen(false)
            })
            .catch((err) => {
                console.error('复制到剪贴板时出现错误:', err);
                // 创建一个临时的textarea元素
                const textarea = document.createElement('textarea');
                textarea.value = text

                // 将textarea元素添加到DOM中
                document.body.appendChild(textarea);

                // 选中并复制文本内容
                textarea.select();
                document.execCommand('copy');

                // 移除临时的textarea元素
                document.body.removeChild(textarea);

                message.success('已复制链接')
                setModalOpen(false)
            })
        } else {
            // 创建一个临时的textarea元素
            const textarea = document.createElement('textarea');
            textarea.value = text

            // 将textarea元素添加到DOM中
            document.body.appendChild(textarea);

            // 选中并复制文本内容
            textarea.select();
            document.execCommand('copy');

            // 移除临时的textarea元素
            document.body.removeChild(textarea);

            message.success('已复制链接')
            setModalOpen(false)
        }
    }

    return (
        <PSAIModal
            open={modalOpen}
            footer={null}
            onCancel={() => {setModalOpen(false)}}
            maxWidth={400}
        >
            <div className={styles.MobileModal}>
                <i></i>
                <p>建议电脑浏览器中输入以下链接体验完整功能</p>
                <p>https://www.psai.cn/</p>
                <Button type='primary' onClick={copy}>复制链接</Button>
            </div>
        </PSAIModal>
    )
}

export default MobileModal